import { useState } from "react";

const CONTACT_ITEMS = [
  {
    label: "رقم الهاتف",
    value: "+966 50 123 4567",
    href: "tel:+966501234567",
    icon: "📞",
  },
  {
    label: "البريد الإلكتروني",
    value: "support@memestore.sa",
    href: "mailto:support@memestore.sa",
    icon: "✉️",
  },
  {
    label: "العنوان",
    value: "طريق الملك فهد، الرياض، المملكة العربية السعودية",
    href: null,
    icon: "📍",
  },
  {
    label: "ساعات العمل",
    value: "يومياً من 9 صباحاً حتى 11 مساءً",
    href: null,
    icon: "🕒",
  },
];

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: ربط الفورم بـ API الإرسال الفعلي
    setSent(true);
  };

  return (
    <div dir="rtl" className="max-w-6xl mx-auto px-4 py-12">

      {/* Hero Section */}
      <div className="bg-white rounded-3xl overflow-hidden shadow-lg mb-16">
        <div className="grid md:grid-cols-2 items-center">

          <div className="p-8 md:p-12 text-right">
            <span className="inline-block px-4 py-1 rounded-full bg-[#F2B705]/15 text-[#1B1B1F] text-sm font-bold mb-4">
              دعم متواصل
            </span>

            <h2
              className="text-3xl md:text-5xl font-bold text-[#1B1B1F] mb-4"
              style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
            >
              نحن هنا لخدمتك دائماً
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              سواء كان لديك استفسار عن طلب، منتج، أو تحتاج إلى مساعدة،
              فريق خدمة العملاء جاهز للرد عليك بأسرع وقت.
            </p>

            <div className="flex flex-wrap justify-end gap-4">
              <div className="bg-[#F6F5F2] px-5 py-3 rounded-xl">
                <div className="font-bold text-2xl text-[#1B1B1F]">+50K</div>
                <div className="text-sm text-gray-500">عميل سعيد</div>
              </div>

              <div className="bg-[#F6F5F2] px-5 py-3 rounded-xl">
                <div className="font-bold text-2xl text-[#1B1B1F]">98%</div>
                <div className="text-sm text-gray-500">رضا العملاء</div>
              </div>

              <div className="bg-[#F6F5F2] px-5 py-3 rounded-xl">
                <div className="font-bold text-2xl text-[#1B1B1F]">24/7</div>
                <div className="text-sm text-gray-500">دعم مستمر</div>
              </div>
            </div>
          </div>

          <div>
            <img
              src="https://images.unsplash.com/photo-1556740749-887f6717d7e4?w=1200&q=80"
              alt="Customer Support"
              className="w-full h-full object-cover min-h-[400px]"
            />
          </div>

        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8 items-start">

      {/* نموذج التواصل */}
      <div className="bg-white p-8 rounded-2xl shadow-[0_2px_10px_rgba(27,27,31,0.08)]">
        <h2
          className="text-2xl font-bold text-[#1B1B1F] mb-6"
          style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
        >
          أرسل لنا رسالة
        </h2>

        {sent ? (
          <div className="bg-[#F2B705]/10 border border-[#F2B705]/30 text-[#1B1B1F] rounded-xl p-6 text-center">
            تم إرسال رسالتك بنجاح، سيتواصل معك فريقنا قريباً. شكراً لك 🌟
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-semibold text-[#1B1B1F] mb-2">
                الاسم الكامل
              </label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                placeholder="اكتب اسمك هنا"
                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#F2B705] focus:outline-none focus:ring-2 focus:ring-[#F2B705]/30 transition-colors"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-[#1B1B1F] mb-2">
                البريد الإلكتروني
              </label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                dir="ltr"
                placeholder="example@email.com"
                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#F2B705] focus:outline-none focus:ring-2 focus:ring-[#F2B705]/30 transition-colors text-right"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-semibold text-[#1B1B1F] mb-2">
                الموضوع
              </label>
              <input
                type="text"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                required
                placeholder="عنوان رسالتك"
                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#F2B705] focus:outline-none focus:ring-2 focus:ring-[#F2B705]/30 transition-colors"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-semibold text-[#1B1B1F] mb-2">
                الرسالة
              </label>
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                rows={5}
                placeholder="اكتب تفاصيل استفسارك هنا..."
                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#F2B705] focus:outline-none focus:ring-2 focus:ring-[#F2B705]/30 transition-colors resize-none"
              />
            </div>

            <div className="md:col-span-2">
              <button
                type="submit"
                className="w-full md:w-auto px-8 py-3 rounded-xl bg-[#1B1B1F] text-white font-bold hover:bg-[#F2B705] hover:text-[#1B1B1F] transition-colors"
              >
                إرسال الرسالة
              </button>
            </div>
          </form>
        )}
      </div>

      {/* معلومات التواصل */}
      <div className="bg-white p-8 rounded-2xl shadow-[0_2px_10px_rgba(27,27,31,0.08)]">
        <h2
          className="text-2xl font-bold text-[#1B1B1F] mb-6"
          style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
        >
          معلومات التواصل
        </h2>

        <div className="grid md:grid-cols-2 gap-6">
          {CONTACT_ITEMS.map((item) => (
            <div
              key={item.label}
              className="flex items-start gap-4 text-lg text-gray-700"
            >
              <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-full bg-[#F2B705]/15 text-[#1B1B1F]">
                {item.icon}
              </span>

              <div className="flex-1">
                <p className="font-semibold text-[#1B1B1F] mb-1">
                  {item.label}
                </p>

                {item.href ? (
                  <a
                    href={item.href}
                    dir="ltr"
                    className="block text-gray-600 hover:text-[#1B1B1F] transition-colors underline decoration-[#F2B705] decoration-2 underline-offset-2"
                  >
                    {item.value}
                  </a>
                ) : (
                  <p className="text-gray-600">
                    {item.value}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* الخريطة */}
        <div className="mt-8 overflow-hidden rounded-2xl border border-gray-200">
          <iframe
            title="MEME STORE Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3621.127381111125!2d46.61203897536977!3d24.825317077952178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f1b5ab2e599c1%3A0x58ab1ee4e94e9c89!2sKing%20Fahd%20Rd%2C%20Riyadh%20Saudi%20Arabia!5e0!3m2!1sen!2seg!4v1784394154067!5m2!1sen!2seg"
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            className="w-full"
          />
        </div>
      </div>

      </div>

    </div>
  );
}
